import {
  type ReceiptConfig,
  type ReceiptConfigPayload,
} from "@/features/finance/model/finance-types"
import {
  http,
} from "@/shared/lib/api/http"
import {
  extractFilename,
} from "./finance-api-shared"


export async function getTransactionReceiptPreview(id: string): Promise<{ html: string; fileName: string }> {
  const response = await http.get<{ html: string; fileName: string }>(`/finance/receipts/transactions/${id}/preview`)
  return response.data
}


/** IBA-74: issue (persist) a receipt for a posted income/expense transaction. Idempotent. */
export async function issueTransactionReceipt(id: string): Promise<{ id: string; receiptNumber: string; status: string }> {
  const response = await http.post<{ id: string; receiptNumber: string; status: string }>(
    `/finance/receipts/transactions/${id}/issue`
  )
  return response.data
}


/** The persisted receipt for a transaction, or null if none has been issued. */
export async function getTransactionReceipt(id: string): Promise<{ id: string; receiptNumber: string; status: string } | null> {
  try {
    const response = await http.get<{ id: string; receiptNumber: string; status: string }>(
      `/finance/receipts/transactions/${id}`
    )
    return response.data
  } catch {
    return null
  }
}


export async function downloadTransactionReceiptPdf(id: string): Promise<{ blob: Blob; fileName: string }> {
  const response = await http.get<Blob>(`/finance/receipts/transactions/${id}/pdf`, { responseType: "blob" })
  const contentDisposition = response.headers?.["content-disposition"]
  const headerName = extractFilename(typeof contentDisposition === "string" ? contentDisposition : undefined)
  const fileName = headerName || `receipt-${id}.pdf`
  return { blob: response.data, fileName }
}


export async function getReceiptConfig(input: { workspaceId: string; branchId: string }): Promise<ReceiptConfigPayload> {
  const response = await http.get<ReceiptConfigPayload>("/finance/receipts/config", { params: input })
  return response.data
}


export async function updateReceiptConfig(input: { workspaceId: string; branchId: string; config: ReceiptConfig }): Promise<ReceiptConfig> {
  const response = await http.put<{ config: ReceiptConfig }>("/finance/receipts/config", input)
  return response.data.config
}


export async function previewReceiptConfig(input: { workspaceId: string; branchId: string; config: ReceiptConfig }): Promise<{ html: string }> {
  const response = await http.post<{ html: string }>("/finance/receipts/preview", input)
  return response.data
}
